import React from "react";
import { deploynewcontract } from "../../redux/actions/icoAction";
import { useSelector, useDispatch } from "react-redux";

const DARK = "#0e3725";
const GOLD = "#c9a84c";

const fieldStyle = {
	width: "100%",
	padding: "12px 16px",
	border: "1px solid #d1d5db",
	borderRadius: 10,
	fontSize: 14,
	color: "#111827",
	background: "#fff",
	outline: "none",
	boxSizing: "border-box",
	fontFamily: "inherit",
	transition: "border-color 0.2s",
};

const labelStyle = {
	display: "block",
	fontSize: 12,
	fontWeight: 700,
	color: "#374151",
	textTransform: "uppercase",
	letterSpacing: "0.06em",
	marginBottom: 7,
};

const errorStyle = {
	display: "block",
	fontSize: 12,
	color: "#dc2626",
	marginTop: 5,
	fontWeight: 500,
};

const DeployNewICO = (property) => {
	const dispatch = useDispatch();
	let tx = 0;
	const { auth, ico } = useSelector((state) => state);
	if (ico.data) {
		var response = ico.data;
		if (response.status == 1) {
			response.errors = 0;
			tx = response.receipt;
		}
	}

	const handleDeploy = (e) => {
		e.preventDefault();
		const { contractName, symbol, totalsupply } = e.target.elements;
		let contractData = {
			propertyId: property.data._id,
			contractName: contractName.value,
			symbol: symbol.value,
			totalsupply: totalsupply.value,
		};
		dispatch(deploynewcontract(contractData, auth));
	};

	// Don't render anything until property data is loaded
	const isLoaded = property.data && property.data._id;

	return (
		<div style={{ padding: "28px 0" }}>
			{/* Documents verification panel */}
			<div style={{
				background: "#fff",
				border: "1px solid #e5e7eb",
				borderRadius: 10,
				padding: "18px 20px",
				marginBottom: 24,
			}}>
				<p style={{ margin: "0 0 14px", fontSize: 12, fontWeight: 700, color: "#374151", textTransform: "uppercase", letterSpacing: "0.07em" }}>Property Documents</p>
				{!isLoaded ? (
					<div style={{ display: "flex", gap: 10 }}>
						<div style={{ width: 140, height: 38, borderRadius: 8, background: "#f3f4f6", animation: "pulse 1.5s infinite" }} />
						<div style={{ width: 80, height: 38, borderRadius: 8, background: "#f3f4f6", animation: "pulse 1.5s infinite" }} />
					</div>
				) : (
				<div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "flex-start" }}>
					{/* Property Deed */}
					{property.data && property.data.propertyDeed && property.data.propertyDeed.startsWith('http') ? (
						<a
							href={property.data.propertyDeed}
							target="_blank"
							rel="noreferrer"
							style={{
								display: "inline-flex", alignItems: "center", gap: 8,
								padding: "10px 16px", borderRadius: 8,
								background: "rgba(14,55,37,0.06)", border: "1px solid rgba(14,55,37,0.2)",
								color: DARK, fontSize: 13, fontWeight: 600, textDecoration: "none",
							}}
						>
							<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
								<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
								<polyline points="14 2 14 8 20 8" />
							</svg>
							View Property Deed
						</a>
					) : property.data && property.data.propertyDeed ? (
						<span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "10px 16px", borderRadius: 8, background: "rgba(234,179,8,0.1)", border: "1px solid rgba(234,179,8,0.3)", color: "#854d0e", fontSize: 12, fontWeight: 600 }}>
							<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
							Old deed file — re-upload via Edit Property tab
						</span>
					) : (
						<span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "10px 16px", borderRadius: 8, background: "rgba(239,68,68,0.07)", border: "1px solid rgba(239,68,68,0.2)", color: "#dc2626", fontSize: 12, fontWeight: 600 }}>
							<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
							No deed uploaded — go to Edit Property tab to add one
						</span>
					)}
					{/* Property image thumbnails */}
					{property.data && property.data.imageName && property.data.imageName.slice(0, 4).map((img, idx) => (
						<img key={idx} src={img} alt="Property"
							style={{ width: 80, height: 56, objectFit: "cover", borderRadius: 7, border: "1px solid #e5e7eb" }}
							onError={(e) => { e.target.style.display = "none"; }}
						/>
					))}
				</div>
				)}
			</div>
			{/* Info banner */}
			<div style={{
				background: "rgba(14,55,37,0.06)",
				border: "1px solid rgba(14,55,37,0.15)",
				borderRadius: 10,
				padding: "14px 18px",
				marginBottom: 28,
				display: "flex",
				alignItems: "flex-start",
				gap: 12,
			}}>
				<svg width="18" height="18" fill="none" stroke={DARK} strokeWidth="2" viewBox="0 0 24 24" style={{ marginTop: 1, flexShrink: 0 }}>
					<circle cx="12" cy="12" r="10" />
					<line x1="12" y1="8" x2="12" y2="12" />
					<line x1="12" y1="16" x2="12.01" y2="16" />
				</svg>
				<div>
					<p style={{ margin: 0, fontSize: 13, fontWeight: 700, color: DARK }}>BEP-20 Token Deployment</p>
					<p style={{ margin: "3px 0 0", fontSize: 12, color: "#4b7a5e" }}>
						This will deploy a new BEP-20 smart contract on the BSC network. Ensure the symbol is unique and the total supply matches the tokenization plan.
					</p>
				</div>
			</div>

			<form onSubmit={(e) => handleDeploy(e)}>
				<div style={{ display: "grid", gap: 20 }}>
					{/* Property Name */}
					<div>
						<label style={labelStyle}>Property Name</label>
						<div style={{ position: "relative" }}>
							<input
								type="text"
								style={{ ...fieldStyle, background: "#f9fafb", color: "#6b7280", cursor: "not-allowed" }}
								value={property.data ? property.data.title : ""}
								name="contractName"
								readOnly
							/>
							<span style={{
								position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
								fontSize: 10, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase",
								letterSpacing: "0.08em", background: "#f3f4f6", padding: "2px 8px", borderRadius: 4,
							}}>Read-only</span>
						</div>
						<span style={errorStyle}>{ico.data ? ico.data.errors.contractName : ""}</span>
					</div>

					{/* Symbol + Total Supply side by side */}
					<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
						<div>
							<label style={labelStyle}>Token Symbol</label>
							<input
								type="text"
								style={fieldStyle}
								placeholder="e.g. ALMRG"
								name="symbol"
								onFocus={(e) => (e.target.style.borderColor = GOLD)}
								onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
							/>
							<span style={errorStyle}>{ico.data ? ico.data.errors.symbol : ""}</span>
							<p style={{ margin: "5px 0 0", fontSize: 11, color: "#9ca3af" }}>Short uppercase identifier (3–5 chars)</p>
						</div>
						<div>
							<label style={labelStyle}>Total Token Supply</label>
							<input
								type="number"
								style={fieldStyle}
								placeholder="e.g. 1000000"
								name="totalsupply"
								min="1"
								onFocus={(e) => (e.target.style.borderColor = GOLD)}
								onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
							/>
							<span style={errorStyle}>{ico.data ? ico.data.errors.totalsupply : ""}</span>
							<p style={{ margin: "5px 0 0", fontSize: 11, color: "#9ca3af" }}>Total fractional tokens to mint</p>
						</div>
					</div>

					{/* Deploy button */}
					<div style={{ paddingTop: 8 }}>
						<button
							type="submit"
							style={{
								width: "100%",
								padding: "14px 24px",
								background: `linear-gradient(135deg, ${GOLD} 0%, #b8943e 100%)`,
								color: "#fff",
								border: "none",
								borderRadius: 10,
								fontSize: 15,
								fontWeight: 700,
								cursor: "pointer",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 10,
								letterSpacing: "0.02em",
								boxShadow: "0 4px 14px rgba(201,168,76,0.35)",
								transition: "transform 0.15s, box-shadow 0.15s",
							}}
							onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 6px 20px rgba(201,168,76,0.45)"; }}
							onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 14px rgba(201,168,76,0.35)"; }}
						>
							<svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
								<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
							</svg>
							Deploy Property Token
						</button>
						<p style={{ textAlign: "center", margin: "10px 0 0", fontSize: 11, color: "#9ca3af" }}>
							This action is irreversible. Double-check all values before deploying.
						</p>
					</div>
				</div>
			</form>
		</div>
	);
};

export default DeployNewICO;
